export const CALLOUT_SUCCESS = "success";
export const CALLOUT_INFO = "info";
export const CALLOUT_WARNING = "warning";
export const CALLOUT_ERROR = "error";
